import { FunctionComponent, useEffect } from 'react'
import { Box, Button, Divider, Typography } from '@mui/material'
import PageWrapper from 'hoc/PageWrapper'
import { useTranslation } from 'react-i18next'
import { TablePagination } from 'components/TablePagination'
import { useBoolean } from 'hooks/useBoolean'
import { useQueryState } from 'react-router-use-location-state'
import { Loading } from 'components/Loading'
import { Error } from 'components/Error'
import { DialogCreateReport } from './dialog-create-report'
import {
  useDeleteReportMutation,
  useReportsQuery,
} from 'services/info-center/reports'
import { ReportTable } from './report-table'
import { toast } from 'react-toastify'

export const Reports: FunctionComponent = () => {
  const { t } = useTranslation()
  const dialogCreateReport = useBoolean(false)

  const [page, setPage] = useQueryState('page', 0)
  const rowsPerPage = 10

  const args = {
    page,
    size: rowsPerPage,
    keyword: '',
  } as const

  const { data: reports, isError, isLoading } = useReportsQuery(args)
  const [
    deleteReport,
    { isSuccess: isDeleteReportSuccess, isError: isDeleteReportError },
  ] = useDeleteReportMutation()

  const handleDeleteReport = (id: string) => {
    deleteReport({ id })
  }

  useEffect(() => {
    if (isDeleteReportSuccess) {
      toast.success(t('operation-success'))
    }

    if (isDeleteReportError) {
      toast.success(t('operation-failure'))
    }
  }, [isDeleteReportSuccess, isDeleteReportError, t])

  if (isLoading) return <Loading />

  if (isError) return <Error />

  if (reports === undefined) {
    return <></>
  }

  return (
    <PageWrapper>
      {dialogCreateReport.isTrue && (
        <DialogCreateReport onClose={dialogCreateReport.setFalse} />
      )}
      <Box display="flex" justifyContent="space-between">
        <Typography fontWeight="bold" variant="h6">
          {t('reports')}
        </Typography>
        <Button
          color="primary"
          variant="contained"
          style={{ color: '#fff', backgroundColor: 'rgb(3, 34, 76)' }}
          onClick={dialogCreateReport.setTrue}
        >
          {t('create')}
        </Button>
      </Box>

      <Divider sx={{ my: 1.5 }} />

      {reports && reports.items.length > 0 && (
        <ReportTable reports={reports.items} onDelete={handleDeleteReport} />
      )}

      {reports.info.totalRows !== 0 && (
        <TablePagination
          total={reports.info.totalRows}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={setPage}
        />
      )}
    </PageWrapper>
  )
}
